import { useDispatch } from 'react-redux';
import React from 'react'

import Select from "react-select";
import { useSelector } from 'react-redux';
import {
  associationLovSelector,
  fetchAssociationLov,
  selectedObjectTypeFilterSelector,
  setAssociationFilterInput,
  setSelectedAssociationFilter,
  selectedAssociationFilterSelector,
} from 'stores/redux/slice/manageCommitte';


const all = { label: 'All', value: '' }

export default function AssociationLov({ name, label, gridController, lov }) {
  const associationLov = useSelector(associationLovSelector) || lov
  const selectedValue = useSelector(selectedAssociationFilterSelector)

  const selectedObjectType = useSelector(selectedObjectTypeFilterSelector);
  const dispatch = useDispatch();

  return (
    <>
      <label htmlFor={`filter-${name}`} className="invisible">
        {label}
      </label>
      <Select
        value={selectedValue}
        className="grid-reactSelect-wrapper"
        classNamePrefix="grid-reactSelect"
        id={`filter-id-${name}`}
        inputId={`filter-${name}`}
        data-id={`filter-${name}`}
        options={[all, ...associationLov]}
        name={name}
        defaultValue={all}
        menuPosition="absolute"
        menuPortalTarget={document.body}
        gridController={gridController}
        classNames={{
          option: () => `menu-item-${name}`
        }}
        onMenuOpen={() => {
          dispatch(fetchAssociationLov({ association: 'All', objtype: selectedObjectType?.value || 'All' }))
        }}
        onInputChange={(t) => {
          if (t.length > 1) {
            dispatch(setAssociationFilterInput(t))
            dispatch(fetchAssociationLov({ association: t, objtype: selectedObjectType?.value || 'All' }))
          } else {
            dispatch(fetchAssociationLov({ association: 'All', objtype: selectedObjectType?.value || 'All' }))
          }
        }
        }
        onChange={(option) => {
          dispatch(setSelectedAssociationFilter(option))
          gridController.current.filterExternally({
            esysId: option?.value
          });
        }}
        styles={{ menuPortal: (base) => ({ ...base, minWidth: "10rem", zIndex: 999 }) }}
      />
    </>

  )
}


